/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
const ImagePreview = (props) => {
    const { src, title, alt } = props;
    return (jsx("a", { href: src, target: "_blank", rel: "noopener noreferrer", css: { display: 'inline-block' } },
        jsx("img", { 
            // NOTE: `loading="lazy"` is very important to suppress unnecessary loading of the image,
            // ReactEditor.toSlatePoint and Range.cloneContents() inside it are called
            // and it copies the dom <img> node, basically on every keystrokes,
            // that leads to fetch an new image resource unnecessarily unless `loading="lazy"` is set.
            // About Range.cloneContents() in ReactEditor.toSlatePoint,
            // See https://github.com/ianstormtaylor/slate/blob/1d7ab974292a3e831908a2ba0aab9fdd8a66fe10/packages/slate-react/src/plugin/react-editor.ts#L386
            loading: "lazy", decoding: "async" // Not sure if this is effective - but for performance.
            , referrerPolicy: "no-referrer" // For users' security - just in case.
            , src: src, title: title, alt: alt, css: {
                maxWidth: '100%',
                maxHeight: '180px',
                display: 'block',
            } })));
};
export default React.memo(ImagePreview);
//# sourceMappingURL=Preview.js.map